import { cva as l } from "class-variance-authority";
const e = l(
  [
    "shrink-0 fill-current ",
    "block align-middle"
    // Needed to align the icon when preflight styles not included, i.e. in Belen.
  ],
  {
    variants: {
      /**
       * Sets the size of the icon.
       */
      size: {
        small: ["w-small", "h-small"],
        medium: ["w-medium", "h-medium"],
        large: ["w-large", "h-large"],
        xlarge: ["w-xlarge", "h-xlarge"],
        xxlarge: ["w-xxlarge", "h-xxlarge"]
      }
    },
    defaultVariants: {
      size: "large"
    }
  }
);
export {
  e as svgIconStyles
};
